import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any
import { addLevelAddSchoolModel } from "../../../../../components/dataAnalytics/dataAnalytics.model";


@Component({
  selector: 'LevelAddSchoolH',
  templateUrl: 'AddLevelAddSchoolH.component.html',
  styleUrls: ['AddLevelAddSchoolH.component.scss'],

})
export class AddLevelAddSchoolHComponent implements OnInit {
  AddLevelAddSchoolModel = new addLevelAddSchoolModel();
  display = "none";
  display1 = "none";
  public schoolId: any;
  public userId: string;
  public ShowLevelData: any;

  public selectedlevel: string = "";
  public selectedlevelid: string = "";
  public selectedlevelname: string = "";

  constructor(
    private dataAnalyticsService: DataAnalyticsService,
    private messageService: MessageService,
    private noticeboardService: NoticeboardService,
    private confirmationService: ConfirmationService,
    private localStorage: LocalStorageService
  ) {
    this.schoolId = this.localStorage.retrieve("SchoolId");
    this.userId = this.localStorage.retrieve("id");
  }

  ngOnInit() {
    this.getLevelsName();
  }
//-------------------------------------------------------GET----------------------------------------------------
  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        console.log("ShowLevelData", this.ShowLevelData);
      });
  }
//-------------------------------------------------------Post----------------------------------------------------

  postLeveladdSchool() {
    var payload = {
      schoolid:this.schoolId,
      levels: this.selectedlevelname,
    };
    this.dataAnalyticsService
      .postLevel(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Level Added Successfully",
          });
          this.display1 = "none";
          this.getLevelsName();
        },
        (error) => {}
      );
    this.display = "none";
  }
  //-------------------------------------------------------Update----------------------------------------------------

  updateLeveladdSchool() {
    var payload = {
      Id: this.selectedlevelid,
      Level: this.selectedlevelname,

    };
    this.dataAnalyticsService
      .updateSLevel(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Level Update Successfully",
          });
          this.display1 = "none";
          this.getLevelsName();
        },
        (error) => {}
      );
    this.display1 = "none";
  }

  AddLevel() {
    this.display = "block";
  }

  EditLevel(level: any) {
    this.display1 = "block";
    this.selectedlevelname = level.levels;
    this.selectedlevelid = level.Id;
    this.selectedlevel = level;

  }

  onCloseHandled() {
    this.display = "none";
    this.display1 = "none";
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/LevelAddSchool/AddLevelAddSchoolH.ts